import { useMinimizedWorkoutStore } from '@/stores/minimizedWorkoutStore';
import { Dumbbell, X } from 'lucide-react';
import { useState } from 'react';
import { WorkoutDetailDialog } from './WorkoutDetailDialog';

/**
 * Global floating pill rendered when a WorkoutDetailDialog is minimized.
 * Renders bottom-right of viewport. Click to restore. Hidden on mobile.
 */
export function MinimizedWorkoutPill() {
  const { workout, clear } = useMinimizedWorkoutStore();
  const [restored, setRestored] = useState(false);

  if (!workout) return null;

  const handleRestore = () => setRestored(true);

  const handleClose = (open: boolean) => {
    if (!open) {
      setRestored(false);
      clear();
    }
  };

  const handleMinimize = () => {
    // Keep store value, just collapse back to pill
    setRestored(false);
  };

  return (
    <>
      {!restored && (
        <div
          className="hidden sm:flex fixed bottom-4 right-4 z-40 items-center gap-2 max-w-xs"
          data-testid="minimized-workout-pill"
        >
          <button
            type="button"
            onClick={handleRestore}
            className="flex items-center gap-2 px-3 py-2 rounded-full bg-card border border-border shadow-lg hover:bg-accent transition-colors"
            aria-label={`Restore workout: ${workout.name}`}
          >
            <Dumbbell className="h-4 w-4 text-primary flex-shrink-0" />
            <span className="text-sm font-medium truncate max-w-[180px]">{workout.name}</span>
          </button>
          <button
            type="button"
            onClick={clear}
            aria-label="Dismiss minimized workout"
            data-testid="minimized-workout-pill-dismiss"
            className="h-7 w-7 rounded-full bg-card border border-border shadow-lg flex items-center justify-center hover:bg-accent transition-colors"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      )}
      {restored && (
        <WorkoutDetailDialog
          workout={workout}
          open
          onOpenChange={handleClose}
          onMinimize={handleMinimize}
        />
      )}
    </>
  );
}

export { useMinimizedWorkoutStore };
